export var defaultLuminanceScale = {
    zero: 1,
    10: 0.9301108583754237,
    13: 0.849131002811465,
    15: 0.7681511472475069,
    20: 0.4029444004475269,
    30: 0.2719925824996081,
    45: 0.16940419557539813,
    70: 0.08727207964033774,
    100: 0.03897641464406361,
    150: 0.015208514422912708,
    max: 0
};
export var darkLuminanceScale = {
    zero: 0,
    10: 0.014718499487226425,
    13: 0.021019695563151,
    15: 0.027320891639074897,
    20: 0.039923283790923,
    30: 0.162029375639111,
    45: 0.25129572170428216,
    70: 0.41559710957572116,
    100: 0.747551034001112,
    150: 0.9301108583754237,
    max: 1
};
export default {
    default: defaultLuminanceScale,
    dark: darkLuminanceScale
};
